import { Component, inject, Input, OnInit } from '@angular/core';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { IProduct } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { getMasterFirmwareVersionFromPool } from '../../../../../../ECoSystemsHelper';
import {
  DataProductType,
  PoolDataApi,
} from '../../../../../../../../apis/poolData.api';
import Moment from 'moment';

@Component({
  selector: 'app-p00039-card-puissance-statut',
  templateUrl: './p00039-card-puissance-statut.component.html',
  styleUrls: ['./p00039-card-puissance-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P00039CardPuissanceStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  private poolDataApi = inject(PoolDataApi);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];

  public previousPowerData: number | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P00039.card.state.cover.title.open',
        icon: 'fa-kit fa-picto-couvfermeedeux',
        color: 'color-green',
        status: 'active',
      },
      {
        title: 'P00039.card.state.cover.title.close',
        icon: 'fa-kit fa-picto-couvouvertedeux',
        color: 'color-red',
        status: 'inactive',
      },
    ];

    if (
      getMasterFirmwareVersionFromPool(
        this.edroNetworkManager!.getPoolContext()!.pool!,
      )! >= 9
    ) {
      this.poolDataApi
        .getPoolProductDatas(
          this.edroNetworkManager.getPoolContext()!.pool!.id!,
          DataProductType.MASTER,
          'P00039',
          'deviceTableSPuissanceApparenteTotal',
          'delta',
          Moment(
            Moment().subtract(7, 'day').format('YYYY-MM-DD') + 'T00:00:00',
          ).unix(),
          Moment(Moment().format('YYYY-MM-DD') + 'T23:59:59').unix(),
        )
        .then((productEvents) => {
          if (productEvents.length > 0) {
            this.previousPowerData =
              productEvents[productEvents.length - 1].value;
          } else {
            this.previousPowerData = 0;
          }
        })
        .catch((e) => {
          this.previousPowerData = null;
        });
    }
  }

  showCard() {
    if (
      getMasterFirmwareVersionFromPool(
        this.edroNetworkManager.getPoolContext().pool!,
      )! < 9
    ) {
      return false;
    }

    return true;
  }

  getMode() {
    if (this.previousPowerData !== null) {
      return (
        Number(
          this.actionStack!.getValue('deviceTableSPuissanceActive') / 1000,
        ).toFixed(1) +
        'kW ' +
        '(' +
        this.translateService.instant('P00039.card.puissance.today') +
        ' ' +
        Number(this.previousPowerData / 1000).toFixed(1) +
        'kWh)'
      );
    }

    return (
      Number(
        this.actionStack!.getValue('deviceTableSPuissanceActive') / 1000,
      ).toFixed(1) + 'kW'
    );
  }
}
